import { lockBodyScroll, unlockBodyScroll } from '../utils/theme-functions.js';

export default class SideDrawer extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.toggleSelector = `[${this.dataset.toggleAttribute}]`;
        document.querySelectorAll(this.toggleSelector).forEach((el) => {
            //if inside drawer it's handled by drawer click
            if (!this.contains(el)) {
                el.addEventListener('click', () => {
                    this.toggle();
                });
            }
        });

        this.addEventListener('click', this.handleDrawerClick.bind(this));

        this.addEventListener('keyup', (evt) => {
            if (evt.key === 'Escape') this.close();
        });
    }

    handleDrawerClick(evt) {
        const button = evt.target.closest(this.toggleSelector);

        if (!button) return;

        evt.preventDefault();
        this.toggle();
    }

    get isOpen() {
        return this.getAttribute('open') !== null;
    }

    toggle() {
        this.isOpen ? this.close() : this.open();
    }

    open() {
        this.toggleAttribute('open', true);

        lockBodyScroll();
    }

    close() {
        this.toggleAttribute('open', false);

        unlockBodyScroll();
    }
}

customElements.define('side-drawer', SideDrawer);
